module.exports = __webpack_public_path__ + "img/logo_bflab.f1196937.png";